/* global axios */
import ApiClient from './ApiClient';

// The burst id is the id of its first message: nothing is stored for a detected send, so the id has
// to be something a recomputation reproduces.
class DetectedCampaigns extends ApiClient {
  constructor() {
    super('detected_campaigns', { accountScoped: true });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  formalize(id, title) {
    return axios.post(`${this.url}/${id}/formalize`, { title });
  }

  dismiss(id) {
    return axios.post(`${this.url}/${id}/dismiss`);
  }

  // One request for the whole selection: detection is a scan over two years of messages, and the
  // per-burst endpoints would run it once per id.
  bulkFormalize(bursts) {
    return axios.post(`${this.url}/bulk_formalize`, { bursts });
  }

  bulkDismiss(ids) {
    return axios.post(`${this.url}/bulk_dismiss`, { ids });
  }
}

export default new DetectedCampaigns();
